export default {
  name: 'main_item',
  methods: {
    goToPage (path) {
      this.$store.state.historyPage = this.$route.path
      this.$router.push(path)
    },
    doing () {
      alert('รอดำเนินการ')
    }
  },
  mounted () {
    this.$store.state.historyPage = ''
    this.checkUser()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/main_store.js